import ControlDown from '../../../../../../assets/images/ControlDown.svg';
import ControlUp from '../../../../../../assets/images/ControlUp.svg';
import {
  ContainerValidationRoomsBathrooms,
  StyledButton,
  TitleNameCounterValidations,
} from '../ValidationRoomsBathrooms/styles';
import DetailElevatorTypology from '../DetailElevatorTypology/DetailElevatorTypology';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../redux/hooks';
import { updateShowDetail } from '../../../../../../redux/reducers/searchSlice';

const ElevatorTypology = () => {
  const showDetail = useSelector((state: any) => state.searchStore.showDetail);
  const dispatch = useAppDispatch();
  const imgControl = showDetail ? ControlUp : ControlDown;
  const handleChangeShowDetail = () => {
    dispatch(
      updateShowDetail({
        itemName: 'elevator',
        itemValue: !showDetail.elevator,
      })
    );
  };
  return (
    <ContainerValidationRoomsBathrooms>
      <TitleNameCounterValidations>
        <div className="icon-title">
          <StyledButton
            onClick={handleChangeShowDetail}
            data-testid="show-data"
          >
            <img src={imgControl} alt="ampliar replegar" />
          </StyledButton>
          <div className="title">Validación Tipología de ascensores</div>
        </div>
      </TitleNameCounterValidations>
      {showDetail.elevator && <DetailElevatorTypology />}
    </ContainerValidationRoomsBathrooms>
  );
};

export default ElevatorTypology;
